import {
  ARCHIVE_PROMOTION_FAILURE,
  ARCHIVE_PROMOTION_SUCCESS,
  CLONE_PRODUCT_ATTRIBUTES,
  CLONE_PRODUCT_ATTRIBUTES_FAILURE,
  CREATE_ATTRIBUTE,
  CREATE_ATTRIBUTE_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE,
  CREATE_PRODUCT_ATTRIBUTE_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  CREATE_PROMOTIONAL_CATEGORY,
  CREATE_PROMOTIONAL_CATEGORY_FAILURE,
  CREATE_PROMOTION_FAILURE,
  CREATE_PROMOTION_SUCCESS,
  CREATE_RECOMMENDATION,
  CREATE_RECOMMENDATION_FAILURE,
  CREATE_RECOMMENDED_PRODUCT_FAILURE,
  CREATE_RECOMMENDED_PRODUCT_SUCCESS,
  CREATE_TAG,
  CREATE_TAG_FAILURE,
  CREATE_TAX_CATEGORY,
  CREATE_TAX_CATEGORY_FAILURE,
  CREATE_USER,
  CREATE_USER_FAILURE,
  CREATE_VARIANT,
  CREATE_VARIANT_FAILURE,
  DELETE_ATTRIBUTE,
  DELETE_ATTRIBUTE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE,
  DELETE_PRODUCT_ATTRIBUTE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  DELETE_PROMOTIONAL_CATEGORY,
  DELETE_PROMOTIONAL_CATEGORY_FAILURE,
  DELETE_RECOMMENDATION,
  DELETE_RECOMMENDED_PRODUCT_FAILURE,
  DELETE_RECOMMENDED_PRODUCT_SUCCESS,
  DELETE_TAX_CATEGORY,
  DELETE_TAX_CATEGORY_FAILURE,
  DELETE_VARIANT,
  DELETE_VARIANT_FAILURE,
  GET_PROMOTIONAL_CATEGORIES_FAILURE,
  GET_TAX_CATEGORIES_FAILURE,
  REFUNDED_PRODUCTS_FAILURE,
  REFUNDED_PRODUCTS_SUCCESS,
  RESEND_RECEIPT_FAILURE,
  RESEND_RECEIPT_SUCCESS,
  SAVE_USER,
  SAVE_USER_FAILURE,
  SET_RECOMMENDED_PRODUCTS_FAILURE,
  SET_SURCHARGES_FAILURE,
  SET_TAG_FAILURE,
  SET_TAX_RATES_FAILURE,
  UPDATED_TAX_RATES,
  UPDATED_TAX_RATES_FAILURE,
  UPDATE_ATTRIBUTE,
  UPDATE_ATTRIBUTE_FAILURE,
  UPDATE_ATTRIBUTE_VALUES_FAILURE,
  UPDATE_MENU_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE,
  UPDATE_PRODUCT_ATTRIBUTE_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  UPDATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PROMOTIONAL_CATEGORY,
  UPDATE_PROMOTIONAL_CATEGORY_FAILURE,
  UPDATE_PROMOTION_FAILURE,
  UPDATE_PROMOTION_SUCCESS,
  UPDATE_RECOMMENDATION,
  UPDATE_RECOMMENDATION_FAILURE,
  UPDATE_RECOMMENDED_PRODUCT_FAILURE,
  UPDATE_RECOMMENDED_PRODUCT_SUCCESS,
  UPDATE_TAG,
  UPDATE_TAG_FAILURE,
  UPDATE_TAX_CATEGORY,
  UPDATE_TAX_CATEGORY_FAILURE,
  UPDATE_VARIANT,
  UPDATE_VARIANT_FAILURE,
} from '@store/action-list'
import {
  CLONE_PRODUCT_FAILURE,
  CLONE_PRODUCT_SUCCESS,
} from '@store/reducers/products/actions'
import { getTags } from '@store/actions/tags'
import { put, takeEvery } from 'redux-saga/effects'
import { setFlashMessage } from '@store/reducers/flash-message/actions'

const notificationMapping = {
  [UPDATE_PRODUCT_SUCCESS]: 'Product Updated',
  UPDATE_PRODUCT_FAILURE,
  [DELETE_RECOMMENDATION]: 'Recommendation Deleted',
  [UPDATE_RECOMMENDATION]: 'Recommendation Updated',
  UPDATE_RECOMMENDATION_FAILURE,
  [CREATE_RECOMMENDATION]: 'Recommendation Created',
  CREATE_RECOMMENDATION_FAILURE,
  [CLONE_PRODUCT_SUCCESS]: 'Product Attributes Cloned',
  CLONE_PRODUCT_FAILURE,
  CREATE_USER_FAILURE,
  [CREATE_USER]: 'Created User',
  SAVE_USER_FAILURE,
  [SAVE_USER]: 'Updated User',
  UPDATE_ATTRIBUTE_VALUES_FAILURE,
  SET_TAG_FAILURE,
  UPDATE_TAG_FAILURE,
  CREATE_TAG_FAILURE,
  [CREATE_TAG]: 'Tag Created',
  [UPDATE_TAG]: 'Tag Updated',
  [getTags.rejected.type]: 'Failed to get tags',
  [UPDATED_TAX_RATES]: 'Tax Rates Updated',
  [UPDATED_TAX_RATES_FAILURE]: 'Woops we could not update the tax rates!',
  [SET_TAX_RATES_FAILURE]: 'Could not fetch tax rates',
  [SET_SURCHARGES_FAILURE]: 'Could not fetch surcharges',
  [UPDATE_PROMOTION_SUCCESS]: 'Promotion Updated',
  UPDATE_PROMOTION_FAILURE,
  [CREATE_PROMOTION_SUCCESS]: 'Promotion Created',
  CREATE_PROMOTION_FAILURE,
  [ARCHIVE_PROMOTION_SUCCESS]: 'Promotion Archived',
  ARCHIVE_PROMOTION_FAILURE,
  [CREATE_RECOMMENDED_PRODUCT_SUCCESS]: 'Recommended Product Created',
  [UPDATE_RECOMMENDED_PRODUCT_SUCCESS]: 'Recommended Product Updated',
  [DELETE_RECOMMENDED_PRODUCT_SUCCESS]: 'Recommended Product Deleted',
  CREATE_RECOMMENDED_PRODUCT_FAILURE,
  DELETE_RECOMMENDED_PRODUCT_FAILURE,
  SET_RECOMMENDED_PRODUCTS_FAILURE,
  UPDATE_RECOMMENDED_PRODUCT_FAILURE,
  [REFUNDED_PRODUCTS_SUCCESS]: 'Refund Completed',
  REFUNDED_PRODUCTS_FAILURE,
  [RESEND_RECEIPT_SUCCESS]: 'Customer receipt sent',
  RESEND_RECEIPT_FAILURE,
  UPDATE_MENU_FAILURE,
  [CREATE_ATTRIBUTE]: 'Created Attribute',
  CREATE_ATTRIBUTE_FAILURE,
  [UPDATE_ATTRIBUTE]: 'Updated Attribute',
  UPDATE_ATTRIBUTE_FAILURE,
  [DELETE_ATTRIBUTE]: 'Deleted Attribute',
  DELETE_ATTRIBUTE_FAILURE,
  [CREATE_PRODUCT_ATTRIBUTE]: 'Created Product Attribute',
  CREATE_PRODUCT_ATTRIBUTE_FAILURE,
  [UPDATE_PRODUCT_ATTRIBUTE]: 'Updated Product Attribute',
  UPDATE_PRODUCT_ATTRIBUTE_FAILURE,
  [DELETE_PRODUCT_ATTRIBUTE]: 'Deleted Product Attribute',
  DELETE_PRODUCT_ATTRIBUTE_FAILURE,
  [CREATE_PRODUCT_ATTRIBUTE_VALUE]: 'Created Product Attribute Value',
  CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  [DELETE_PRODUCT_ATTRIBUTE_VALUE]: 'Deleted Product Attribute Value',
  DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  [UPDATE_PRODUCT_ATTRIBUTE_VALUE]: 'Updated product attribute',
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  [CLONE_PRODUCT_ATTRIBUTES]: 'Attribute Values Cloned',
  CLONE_PRODUCT_ATTRIBUTES_FAILURE,
  [CREATE_VARIANT]: 'New Variant Created',
  CREATE_VARIANT_FAILURE,
  [UPDATE_VARIANT]: 'Variant Updated',
  UPDATE_VARIANT_FAILURE,
  [DELETE_VARIANT]: 'Variant Deleted',
  DELETE_VARIANT_FAILURE,
  GET_PROMOTIONAL_CATEGORIES_FAILURE,
  [UPDATE_PROMOTIONAL_CATEGORY]: 'Updated Promotional Category',
  UPDATE_PROMOTIONAL_CATEGORY_FAILURE,
  [CREATE_PROMOTIONAL_CATEGORY]: 'Created Promotional Category',
  CREATE_PROMOTIONAL_CATEGORY_FAILURE,
  [DELETE_PROMOTIONAL_CATEGORY]: 'Deleted Promotional Category',
  DELETE_PROMOTIONAL_CATEGORY_FAILURE,
  GET_TAX_CATEGORIES_FAILURE,
  [UPDATE_TAX_CATEGORY]: 'Updated Tax Category',
  UPDATE_TAX_CATEGORY_FAILURE,
  [CREATE_TAX_CATEGORY]: 'Created Tax Category',
  CREATE_TAX_CATEGORY_FAILURE,
  [DELETE_TAX_CATEGORY]: 'Deleted Tax Category',
  DELETE_TAX_CATEGORY_FAILURE,
}

// TODO: rename
export default function* watchAddProduct(): any {
  yield takeEvery(Object.keys(notificationMapping), updateNotification)
}

function* updateNotification({ type, response: { message, status } }) {
  const displayedMessage = message || notificationMapping[type]

  const variant = [200, 201].includes(status) ? 'success' : 'error'

  yield put(setFlashMessage(displayedMessage, variant))
}
